import React, { useEffect, useState } from "react";
import result from "assets/landing/result.webp";
import GlowEffect from "../../../components/background/GlowEffect";
import {
  BackgroundContainer,
  BackgroundWrapper,
  Container,
  HeroSectionStyled,
  TextWrapper,
  Title,
  Description,
  HeroImage,
} from "./styles";

const HeroSection: React.FC = () => {
  const [isHeroVisible, setIsHeroVisible] = useState<boolean>(false);

  useEffect(() => {
    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsHeroVisible(true);
        } else {
          setIsHeroVisible(false);
        }
      },
      { threshold: 0.4 }
    );
    const heroTarget = document.querySelector(".hero-image");
    if (heroTarget) {
      heroObserver.observe(heroTarget);
    }

    return () => {
      if (heroTarget) {
        heroObserver.unobserve(heroTarget);
      }
    };
  }, []);

  return (
    <BackgroundContainer>
      <BackgroundWrapper $showImage={true}>
        <GlowEffect />
      </BackgroundWrapper>
      <Container>
        <HeroSectionStyled>
          <TextWrapper>
            <Title>
            진입장벽 없는 AI 혁신, <br />
            <span>오디온으로 지금 시작하세요.</span>
            </Title>
            <Description>
              음성 AI 구현의 복잡함을 없애고, 비즈니스 가능성을 확장하세요.
            </Description>
          </TextWrapper>
          <HeroImage className="hero-image">
            <img
              className={isHeroVisible ? "visible" : "hidden"}
              src={result}
              alt="이미지 1"
            />
          </HeroImage>
        </HeroSectionStyled>
      </Container>
    </BackgroundContainer>
  );
};

export default HeroSection;
